<template>
	<section class="page">
		<div class="content-box">
			<edit-order></edit-order>
		</div>
	</section>
</template>

<script>
import EditOrder from "@/views/Reserve/subs/EditOrder.vue";
import TabPage from "@/mixins/TabPage.js";

export default {
	mixins: [TabPage],
	components: {
		EditOrder,
	},
	data() {
		return {
			fakeTabs: {
				indexs: { name: "Order-Index" },
				waitpay: { name: "Order-WaitPay" },
				due: { name: "Order-IndexDue" },
			},
		};
	},
};
</script>
<style lang="scss" scoped>
</style>
